const MOBILE_BREAKPOINT = 768;

const isMobileViewport = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches ||
    window.matchMedia("(pointer: coarse)").matches
  );
};

export const openExternalUrl = (url: string, options?: { newTab?: boolean }) => {
  if (!url) return;
  const preferNewTab = options?.newTab !== false;
  if (!preferNewTab || isMobileViewport()) {
    window.location.assign(url);
    return;
  }

  const opened = window.open(url, "_blank", "noopener,noreferrer");
  if (!opened) {
    window.location.assign(url);
  }
};

export const openExternalBlank = () => {
  if (isMobileViewport()) return null;
  return window.open("", "_blank", "noopener,noreferrer");
};
